// ============================================
// COSMIC HINDU - Category Data
// ============================================

export const categories = [
  {
    id: 'idols',
    name: 'God Idols',
    icon: '🙏',
    description: 'Sacred divine idols crafted with devotion',
    longDescription: 'Handcrafted idols of Hindu deities made from brass, bronze, marble, and panchdhatu. Each idol is blessed before dispatch.',
    image: 'https://images.unsplash.com/photo-1567591414240-e9c1e838fdc7?w=600&h=400&fit=crop',
    slug: 'god-idols',
  },
  {
    id: 'rudraksha',
    name: 'Rudraksha',
    icon: '📿',
    description: 'Blessed Rudraksha beads for spiritual power',
    longDescription: 'Certified Rudraksha beads sourced from Nepal and Indonesia. Available in 1 to 21 Mukhi variants with lab certification.',
    image: 'https://images.unsplash.com/photo-1611516491426-03025e6043c8?w=600&h=400&fit=crop',
    slug: 'rudraksha',
  },
  {
    id: 'karungali',
    name: 'Karungali',
    icon: '🪵',
    description: 'Authentic Karungali wood products',
    longDescription: 'Genuine ebony (Karungali) wood products known for their spiritual protective properties. Sourced from South India.',
    image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=600&h=400&fit=crop',
    slug: 'karungali',
  },
  {
    id: 'jewellery',
    name: 'Spiritual Jewellery',
    icon: '✨',
    description: 'Divine ornaments for spiritual seekers',
    longDescription: 'Sacred jewellery including Om pendants, Trishul rings, temple necklaces, and Rudraksha bracelets in gold, silver, and panchdhatu.',
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600&h=400&fit=crop',
    slug: 'spiritual-jewellery',
  },
  {
    id: 'japamala',
    name: 'Japa Mala',
    icon: '🔮',
    description: 'Sacred counting beads for mantra chanting',
    longDescription: '108-bead malas crafted from Tulsi, Sandalwood, Rudraksha, Sphatik, and Lotus seeds. Perfect for daily sadhana.',
    image: 'https://images.unsplash.com/photo-1590736969955-71cc94901144?w=600&h=400&fit=crop',
    slug: 'japa-mala',
  },
  {
    id: 'astrostone',
    name: 'Astro Stone',
    icon: '💎',
    description: 'Powerful gemstones for cosmic alignment',
    longDescription: 'Certified natural gemstones for all 9 planets (Navaratna). Includes Blue Sapphire, Ruby, Emerald, Pearl, and more with lab reports.',
    image: 'https://images.unsplash.com/photo-1551122087-f99a4ade7874?w=600&h=400&fit=crop',
    slug: 'astro-stones',
  },
  {
    id: 'pooja',
    name: 'Pooja Essentials',
    icon: '🪔',
    description: 'Complete pooja items for daily worship',
    longDescription: 'Everything you need for daily pooja — thali sets, diyas, camphor, incense, kalash, bells, and sacred accessories.',
    image: 'https://images.unsplash.com/photo-1606293926075-69a00dbfde81?w=600&h=400&fit=crop',
    slug: 'pooja-essentials',
  },
];

export const getCategoryById = (id) => categories.find((c) => c.id === id);
export const getCategoryBySlug = (slug) => categories.find((c) => c.slug === slug);
